import { observer } from 'mobx-react-lite';
import HeaderCharm from './HeaderCharm';
import { ControlIcons } from 'owa-control-icons';
import { HeaderCharmType } from 'owa-header-store';
import loc from 'owa-localize';
import { noteFeedFlexPaneTitle } from 'owa-locstrings/lib/strings/notefeedflexpanetitle.locstring.json';
import * as React from 'react';
import { lazyIsPanelOpen } from 'owa-notes-components';
import { lazyIsOneNoteFeedEnabled } from 'owa-notes-feed-bootstrap';

export default observer(function OneNoteCharm(props: {}) {
    return lazyIsOneNoteFeedEnabled.tryImportForRender()?.() ? (
        <HeaderCharm
            key="oneNoteFeed"
            icons={{
                iconName: ControlIcons.OneNoteLogo,
            }}
            ariaLabel={loc(noteFeedFlexPaneTitle)}
            behavior={{
                isActive: lazyIsPanelOpen.tryImportForRender()?.(),
                content: undefined,
                onClick: undefined,
                charm: HeaderCharmType.OneNoteCharm,
            }}
        />
    ) : null;
});
